module.exports = __webpack_public_path__ + "img/logo-ficha-guest.0116023c.png";